import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchChannelAllData,
  fetchChannelConfig,
  fetchChannelLatestData,
  fetchChannelModAllData,
  fetchChannelNames,
} from "../../api/channel";

export const fetchChannelAsync = createAsyncThunk("channel/alldata", async ({ vesselId }) => {
  const { channelData } = await fetchChannelAllData(vesselId);
  return channelData;
});

export const fetchChannelLatestAsync = createAsyncThunk(
  "channel/latestdata",
  async ({ vesselId }) => {
    const data = await fetchChannelLatestData(vesselId);
    return data;
  }
);

export const fetchChannelModAsync = createAsyncThunk("channelmod/alldata", async ({ vesselId }) => {
  const { channelData } = await fetchChannelModAllData(vesselId);
  return channelData;
});

export const fetchChannelNameAndConfig = createAsyncThunk("channelmod/nameAndConfig", async ({vesselId}) => {
  const [names, config] = await Promise.all([
    fetchChannelNames(vesselId, 'channelAsync'),
    fetchChannelConfig(vesselId)
  ]);
  const channelNames = names.names;
  const channelConfig = config.config;

  return {channelNames, channelConfig};
});

export const fulfilledFetchChannelAsync = (state, action) => {
  state.channelData = action.payload;
  state.isChannelFetching = false;
};

export const fulfilledFetchChannelLatestAsync = (state, action) => {
  const map = new Map();
  action.payload.channelConfigData.forEach((item) =>
    map.set(JSON.stringify({ chId: item.chId, fcuNo: item.fcuNo }), {
      chNo: item.chNo,
      unit: item.unit,
      status: item.status || "*",
    })
  );
  action.payload.channelLatestData.forEach((item) =>
    map.set(JSON.stringify({ chId: item.chId, fcuNo: item.fcuNo }), {
      ...map.get(JSON.stringify({ chId: item.chId, fcuNo: item.fcuNo })),
      name: item.chName,
      value: item.inputData || "*",
    })
  );

  state.channelLatestData = Array.from(map.values());
  state.isChannelLatestFetching = false;
};

export const fulfilledFetchChannelModAsync = (state, action) => {
  action.payload.map((item) => {
    item.chNo = item.chNo.toString().padStart(4, "0");
    return item;
  });
  state.channelModData = action.payload;
  state.isChannelModFetching = false;
};

export const fulfilledFetchChannelNameAndConfig = (state, action) => {
  const { channelNames, channelConfig } = action.payload;
  // not display no name channels (it's for internal control)
  const filteredChannelName = channelNames.filter((channel) => channel.chName?.length > 0);
  const namesAndConfigs = filteredChannelName.map((name) => {
    const conf = channelConfig.find((config) => config.chNo === name.chNo);
    return ({
      ...name, 
      ...conf,
    })});
  state.channelNameAndConfigData = namesAndConfigs;
}

export const rejectedFetchChannelAsync = (state, action) => {
  state.isChannelFetching = false;
};

export const rejectedFetchChannelLatestAsync = (state, action) => {
  state.isChannelLatestFetching = false;
};

export const rejectedFetchChannelModAsync = (state, action) => {
  state.isChannelModFetching = false;
};

export const pendingFetchChannelAsync = (state, action) => {
  state.isChannelFetching = true;
};

export const pendingFetchChannelLatestAsync = (state, action) => {
  state.isChannelLatestFetching = true;
};

export const pendingFetchChannelModAsync = (state, action) => {
  state.isChannelModFetching = true;
};
